/* eslint-disable no-underscore-dangle */

import { Equipment } from "types"

// ENV TYPE
export const PROD = "production"
export const STAGING = "staging"
export const DEV = "development"

export const DEFAULT_PHONE_NUMBER = "+33 1 76 41 14 88"

export const CACHED_PROCTORNB_KEY = "CACHED_PROCTORNB_KEY"

export const TRAINING = "u-u-i-d-training"
export const TRAINING_SPREADSHEET = "trainingSpreadSheet.xslx"
export const TRAINING_MP3 = "trainingMp3.mp3"
export const TRAINING_PDF = "trainingPdf.pdf"
export const TRAINING_IMG1 = "trainingImg1.png"
export const TRAINING_IMG2 = "trainingImg2.png"
export const TRAINING_IMG3 = "trainingImg3.png"
export const TRAINING_IMG4 = "trainingImg4.png"
export const TRAINING_IMG5 = "trainingImg5.png"
export const TRAINING_IMG6 = "trainingImg6.png"
export const TRAINING_IMG7 = "trainingImg7.png"
export const TRAINING_IMG8 = "trainingImg8.png"
export const TRAINING_IMG9 = "trainingImg9.png"

export const DEFAULT_LANG = "defaultlang"
export const TIMEZONE = "timezone"

// WIDTH BOOTSTRAP
export const WIDTH_2 = "16.666667%"
export const WIDTH_3 = "25%"
export const WIDTH_5 = "41.666667%"
export const WIDTH_6 = "50%"
export const WIDTH_8 = "66.666667%"
export const WIDTH_10 = "83.333333%"

export const MULTIPLE_CHOICE_QUESTION = "multiple_choice_question"
export const SINGLE_CHOICE_QUESTION = "single_choice_question"
export const SHORT_QUESTION = "short_question"
export const TEXT_BLANKS_QUESTION = "text_blanks_question"
export const TEXT_DROPDOWN_QUESTION = "text_dropdown_question"
export const GRID_SINGLE_CHOICE_QUESTION = "grid_single_choice_question"
export const GRID_MULTIPLE_CHOICE_QUESTION = "grid_multiple_choice_question"
export const AUDIO_QUESTION = "audio_question"
export const VIDEO_QUESTION = "video_question"
export const SPREADSHEET_QUESTION = "spreadsheet_question"
export const DISSERTATION_QUESTION = "dissertation_question"

// MIMETYPE
export {
  MIME_JPEG,
  MIME_JPG,
  MIME_PNG,
  MIME_GIF,
  MIME_IMAGE,
  MIME_PDF,
  MIME_CSV,
  MIME_MS,
  MIME_SHEET,
  MIME_SPREADSHEET,
  MIME_MP4,
  MIME_AVI,
  MIME_WEBM,
  MIME_QUICKTIME,
  MIME_3GP,
  MIME_VIDEO,
  MIME_OCTETSTREAM,
  MIME_MP3,
  MIME_MPEG,
  MIME_MP4A,
  MIME_WEBA,
  MIME_WAV,
  MIME_M4A,
  MIME_AUDIO,
  MIME_DEFAULT,
} from "../../core/constants/mimeTypes"

// PROCTORING
export const PROCTORING_PHOTO_TIMER = 1000 * 5 // 5 seconds
export const PROCTORING_AUDIO_TIMER = 1000 * 60 * 2 // 2 minutes
export const PROCTORING_SCREEN_TIMER = 1000 * 10 // 10 seconds
export const PROCTORING_SCREEN_UPLOAD_TIMEOUT = 1000 * 60 // 60 seconds

// ONBOARDING
export const EXAM_360_AUTOSTART_TIMER = 5

// EACH SECONDS TIMER
export const EACH_SECONDS = 1000

// AUDIO RECORDER
export const AUDIO_RECORDER_INPUT_DEVICEID = "AUDIO_RECORDER_INPUT_DEVICEID"
export const DEFAULT_MEDIA_RECORDING_TIMER = 3

// VIDEO RECORDER
export const VIDEO_RECORDER_INPUT_DEVICEID = "VIDEO_RECORDER_INPUT_DEVICEID"

// VIDEO CONSTRAINT
export const VIDEO_CONSTRAINTS = {
  width: 255,
  height: 200,
  facingMode: "user",
}

export const DEFAULT_EQUIPMENT_CHECK: Omit<
  Equipment,
  | "id"
  | "osVersion"
  | "exam"
  | "memoryTotal"
  | "memoryAvailable"
  | "proxy"
  | "screenNumbers"
  | "screenResolutions"
  | "diskSpaceAvailable"
> = {
  syncDate: "",
  webBrowser: "",
  webVersion: "",
  desktopVersion: "",
  osName: "unknown",
  microphone: false,
  sound: false,
  camera: false,
  networkDownload: -1,
  networkUpload: -1,
}

// HARDWARE REQUIREMENTS (in gigabytes)
export const MIN_MEMORY_IN_GIGA_BYTES = 7
export const MIN_DISK_SPACE_IN_GIGA_BYTES = 10
export const MIN_AVAILABLE_DISK_SPACE_IN_GIGA_BYTES = 2
